import { useMutation } from "@tanstack/react-query";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";
import { useSnackbar } from "../../../contexts/SnackbarContext";
import { handleDownload } from "../../../downloads/utils";
import { backendService } from "../../../services/backend.service";

type Params = {
	departmentId: string;
	locationName: string;
	startDate: string;
	endDate: string;
	fileName: string;
};

export const useFacilityScheduleDownload = () => {
	const { showErrorSnackbar } = useHospitalData();
	const { showSnackbar } = useSnackbar();

	return useMutation({
		mutationFn: async ({ departmentId, locationName, startDate, endDate }: Params) => {
			const response = await backendService.getFacilityScheduleDownload({
				departmentId,
				locationName,
				startDate,
				endDate,
			});
			return response.data as ArrayBuffer;
		},
		onSuccess: (buffer, { fileName }) => {
			handleDownload(buffer, fileName);
			showSnackbar("Schedule downloaded", "success");
		},
		onError: (error) => {
			showErrorSnackbar("Failed to download schedule", {}, error);
		},
	});
};
